import React, { useState, useEffect } from "react";
import useUser from "../Components/Hooks/useUser"
import { Link, useNavigate } from "react-router-dom";
import ErrorMessage from "../Components/Common/ErrorMessage.js"
import LearningLayout from "../Components/LearningPlatform/LearningLayout";
import { FaEnvelope, FaLock, FaSignInAlt } from "react-icons/fa";


function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const userState = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (userState.isSignedIn) {
            navigate('/progress');
        }
    }, [userState.isSignedIn, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await userState.signIn(e, email, password);
    };

    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                <div className='flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8'>
                    <div className='w-full max-w-md'>
                        {/* Form Card */}
                        <div className='bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-white/50 overflow-hidden'>
                            {/* Header */}
                            <div className='bg-gradient-to-r from-violet-600 to-indigo-600 p-8 text-center'>
                                <div className='flex justify-center mb-4'>
                                    <div className='bg-white/20 backdrop-blur-sm p-4 rounded-full'>
                                        <FaSignInAlt className='text-4xl text-white' />
                                    </div>
                                </div>
                                <h1 className='text-3xl font-bold text-white mb-2'>Bem-vindo de volta!</h1>
                                <p className='text-white/90 text-sm'>Entre na sua conta para acompanhar o seu progresso</p>
                            </div>

                            {/* Form */}
                            <form onSubmit={handleSubmit} className='p-8'>
                                {userState.error && (
                                    <div className='mb-6'>
                                        <ErrorMessage />
                                    </div>
                                )}

                                {/* Email Input */}
                                <div className='mb-5'>
                                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                                        Email
                                    </label>
                                    <div className='relative'>
                                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                                            <FaEnvelope className='text-gray-400' />
                                        </div>
                                        <input
                                            type="email"
                                            placeholder="seu@email.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className='w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all duration-200 placeholder-gray-400'
                                        />
                                    </div>
                                </div>

                                {/* Password Input */}
                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                                        Senha
                                    </label>
                                    <div className='relative'>
                                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                                            <FaLock className='text-gray-400' />
                                        </div>
                                        <input
                                            type="password"
                                            placeholder="••••••••"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            className='w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all duration-200 placeholder-gray-400'
                                        />
                                    </div>
                                </div>

                                {/* Forgot Password Link */}
                                <div className='mb-6 text-right'>
                                    <Link
                                        to="/forgot-password"
                                        className='text-sm text-violet-600 hover:text-violet-700 hover:underline transition-colors'
                                    >
                                        Esqueceu sua senha?
                                    </Link>
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className='w-full bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-violet-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02]'
                                >
                                    Entrar
                                </button>

                                {/* Signup Link */}
                                <div className='mt-6 text-center'>
                                    <p className='text-gray-600 text-sm'>
                                        Não tem uma conta?{' '}
                                        <Link
                                            to="/signup"
                                            className='text-violet-600 hover:text-violet-700 font-medium hover:underline transition-colors'
                                        >
                                            Criar conta
                                        </Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
}

export default LoginPage













